import { styled } from "goober";
import { useCallback } from "react";
import { resolveWorkflowFileHref } from "../lib/resolveWorkflowFileHref";
import { useMakeUrl } from "../lib/urls";
import { EmptyState } from "./EmptyState";
import { ReadmeContent } from "./ReadmeContent";
import { SoftButton } from "./SoftButton";

const Outer = styled("div")`
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  container-type: inline-size;
`;

type Props = {
  readme: string | null;
  canWrite: boolean;
  stepNames: readonly string[];
  onAskWriteReadme: () => void;
};

export function WorkflowReadmePanel({
  readme,
  canWrite,
  stepNames,
  onAskWriteReadme,
}: Props) {
  const makeUrl = useMakeUrl();
  const trimmed = readme?.trim();

  const resolveHref = useCallback(
    (href: string) => resolveWorkflowFileHref(href, stepNames, makeUrl),
    [stepNames, makeUrl]
  );

  if (!trimmed) {
    return (
      <Outer>
        <EmptyState
          iconName="notebook-text"
          title="No readme yet"
          description="If this workflow has a readme, it’ll appear here."
          action={
            canWrite ? (
              <SoftButton variant="secondary" onMouseDown={onAskWriteReadme}>
                Ask 3B to write one
              </SoftButton>
            ) : undefined
          }
        />
      </Outer>
    );
  }

  return (
    <Outer>
      <ReadmeContent internalHref={resolveHref}>{trimmed}</ReadmeContent>
    </Outer>
  );
}
